import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f759ba42")

_pushScopeId("data-v-f759ba42")
const _hoisted_1 = {
  key: 0,
  class: "p-2.5"
}
const _hoisted_2 = { class: "px-2.5 bg-white rounded-bl-xl rounded-br-xl pb-3" }
const _hoisted_3 = { class: "bg-white border-t border-gray-lp-2100 flex flex-row gap-3 items-center pt-3" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col h-full p-2.5"
}
const _hoisted_5 = {
  key: 0,
  class: "ml-1 text-xs"
}
const _hoisted_6 = { class: "px-2.5 bg-white rounded-bl-xl rounded-br-xl pb-3" }
const _hoisted_7 = { class: "bg-white border-t border-gray-lp-2100 flex flex-row gap-3 items-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CardListKulionerMerchant = _resolveComponent("CardListKulionerMerchant")!
  const _component_SummaryCard = _resolveComponent("SummaryCard")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_FooterListKulioner = _resolveComponent("FooterListKulioner")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoadingMerchants)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", {
            class: "flex gap-4 p-3 bg-white rounded-tr-xl rounded-tl-xl",
            "aria-label": _ctx.$t('kulioner.merchant.processAriaLabel')
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: tab.routeName,
                to: {
          name: tab.routeName,
          params: { id: _ctx.$route.params.id },
          query: _ctx.$route.query
        }
              }, {
                default: _withId(() => [
                  _createVNode(_component_Skeleton, {
                    width: "158px",
                    height: "32px"
                  })
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ], 8, ["aria-label"]),
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_Skeleton, {
                width: "100%",
                height: "64px"
              }),
              _createVNode(_component_Skeleton, {
                width: "100%",
                height: "64px"
              }),
              _createVNode(_component_Skeleton, {
                width: "100%",
                height: "64px"
              }),
              _createVNode(_component_Skeleton, {
                width: "100%",
                height: "64px"
              })
            ])
          ]),
          _createVNode("div", {
            class: ["flex-1 min-h-0 overflow-y-auto pb-4", [{ 'pb-16': _ctx.status === 'ORDPRC' && _ctx.merchants.length }]]
          }, [
            _createVNode(_component_CardListKulionerMerchant, {
              modelValue: _ctx.merchants,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.merchants = $event)),
              status: _ctx.status,
              loading: _ctx.isLoadingMerchants,
              skeletonCount: 5
            }, null, 8, ["modelValue", "status", "loading"])
          ], 2)
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode("div", {
            class: "flex gap-4 p-3 bg-white rounded-tr-xl rounded-tl-xl",
            "aria-label": _ctx.$t('kulioner.merchant.processAriaLabel')
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: tab.count,
                to: {
            name: tab.routeName,
            params: { id: _ctx.$route.params.id }
          }
              }, {
                default: _withId(({ isActive }) => [
                  _createVNode("button", {
                    class: ["text-gray-lp-300 text-xs font-semibold border-gray-lp-1400 py-2 align-middle rounded-lg border bg-white", [
              { 'text-red-lp-100 bg-red-lp-50': isActive },
              { 'border-pink-lp-300': isActive }
            ]],
                    style: {"width":"158px"}
                  }, [
                    _createTextVNode(_toDisplayString(tab.label) + " ", 1),
                    (tab.count !== undefined)
                      ? (_openBlock(), _createBlock("span", _hoisted_5, " (" + _toDisplayString(tab.count) + ") ", 1))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ], 8, ["aria-label"]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_SummaryCard, {
                variant: "value",
                label: _ctx.$t('kulioner.merchant.summary.totalTransaction'),
                icon: "currency-rp",
                value: _ctx.totalTransactionCompleted,
                linearClass: "linear-green",
                iconColor: "text-green-lp-400"
              }, null, 8, ["label", "value"]),
              _createVNode(_component_SummaryCard, {
                variant: "progress",
                label: _ctx.$t('kulioner.merchant.summary.totalMerchant'),
                icon: "kulioner-merchant",
                completed: _ctx.totalMerchantCompleted,
                total: _ctx.totalMerchant
              }, null, 8, ["label", "completed", "total"]),
              _createVNode(_component_SummaryCard, {
                variant: "progress",
                label: _ctx.$t('kulioner.merchant.summary.totalProduct'),
                icon: "kulioner-product",
                completed: _ctx.totalProductCompleted,
                total: _ctx.totalProduct
              }, null, 8, ["label", "completed", "total"]),
              _createVNode(_component_SummaryCard, {
                variant: "progress",
                label: _ctx.$t('kulioner.merchant.summary.totalItem'),
                icon: "kulioner-item",
                completed: _ctx.totalActualPieces,
                total: _ctx.totalPieces
              }, null, 8, ["label", "completed", "total"])
            ])
          ]),
          (_ctx.merchants.length)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: ["flex-1 min-h-0 overflow-y-auto pb-4", [{ 'pb-16': !!_ctx.merchants.length }]]
              }, [
                _createVNode(_component_CardListKulionerMerchant, {
                  modelValue: _ctx.merchants,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => (_ctx.merchants = $event)),
                    _ctx.updateModelValue
                  ],
                  merchantData: _ctx.merchantsOld,
                  merchantTransaction: _ctx.merchantsTransaction,
                  status: _ctx.status,
                  onUpdate: _ctx.getOrderList
                }, null, 8, ["modelValue", "merchantData", "merchantTransaction", "status", "onUpdate:modelValue", "onUpdate"])
              ], 2))
            : (_openBlock(), _createBlock(_component_EmptyState, {
                key: 1,
                class: "bg-white mt-2 h-full rounded-xl",
                icon: "noData_empty",
                customHeaderMessage: _ctx.$t('kulioner.merchant.emptyHeader'),
                customMessage: _ctx.$t('kulioner.merchant.emptyMessage')
              }, null, 8, ["customHeaderMessage", "customMessage"]))
        ])),
    _createVNode(_Transition, { name: "kulioner-footer" }, {
      default: _withId(() => [
        (_ctx.merchants.length)
          ? (_openBlock(), _createBlock(_component_FooterListKulioner, {
              key: 0,
              status: _ctx.status,
              merchantData: _ctx.merchants,
              selected: _ctx.eligibleOrderIds,
              shipmentIds: _ctx.eligibleOrderIds.map((item) => item.orderShipmentId),
              canBeProcessed: _ctx.canBeProcessed,
              onRefetch: _ctx.getOrderList,
              onClose: _ctx.getOrderList,
              onOnSuccesOrder: _ctx.getOrderList,
              isMerchant: ""
            }, null, 8, ["status", "merchantData", "selected", "shipmentIds", "canBeProcessed", "onRefetch", "onClose", "onOnSuccesOrder"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
})